import InputFileBase64 from "../../../../component/InputFileBase64/InputFileBase64";
import TextInput from "../../../../component/TextInput/TextInput";
import {Fragment, useState} from "react";
import Modal from "react-modal";
import Select from "../../../../component/Select/Select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {baseImagesUrl} from "../../../../assets/Constants";
import ImageInput from "../../../../component/ImageInput/ImageInput";
import {PickDateTime, PickDateTimeWithoutContainer} from "../../../../component/PickDate/PickDate";

const PageForm = ({page, onChange}) => {

    const pageRow = {
        type: "SINGLE",
        title: "",
        icon: "",
        subtitle: "",
        toPageId: "",
        toProductCategoryId: "",
        toNewsCategoryId: "",
        toProductId: "",
        toNewsId: "",
        toBrandId: "",
        parameters: "",
    };
    const rowItem = {
        productId: "",
        banner: "",
        toPageId: "",
        toProductCategoryId: "",
        toNewsCategoryId: "",
        toProductId: "",
        toNewsId: "",
        toBrandId: "",
        parameters: "",
    };
    const [pageForm, setPageForm] = useState(page);
    const [rowModal, setRowModal] = useState({
        show: false,
        index: "",
    });
    const [storyModal, setStoryModal] = useState({
        show: false,
        index: "",
    });
    const story = {
        expirationTimestamp: Math.round(+new Date() / 1000) + (60 * 60 * 24),
        picture: "",
        video: "",
    }
    const changeForm = (key, value) => {
        const newForm = {...pageForm, [key]: value};
        setPageForm(newForm);
        onChange(newForm);
    }

    return (
        <div className="row">
            <div className="col-md-4">
                <InputFileBase64 label={"بک گراوند"} onChange={(value) => {
                    changeForm("background", value);
                }}/>
                {pageForm.background && <img className={"w-100"}
                                             src={pageForm.background.includes("background") ? `${baseImagesUrl}page/${pageForm.background}` : pageForm.background}/>}
            </div>

            <div className="col-md-5">
                <div className="row">
                    <div className={"row"}>

                        {
                            pageForm.stories.map((story, index) => {
                                return (
                                    <div key={index} className="col-md-4">
                                        {story.picture && <img
                                            src={story.picture.includes("story") ? `${baseImagesUrl}story/${story.picture}` : story.picture}
                                            className={"w-100"} alt=""/>}

                                        {story.video && <video className={"w-100"} controls>
                                            <source
                                                src={story.video.includes("story") ? `${baseImagesUrl}story/${story.video}` : story.video}
                                                type="video/mp4"/>
                                            <source
                                                src={story.video.includes("story") ? `${baseImagesUrl}story/${story.video}` : story.video}
                                                type="video/ogg"/>
                                            Your browser does not support the video tag.
                                        </video>}

                                        <button onClick={() => {
                                            setStoryModal({...storyModal, show: true, index: index})
                                        }} className={"btn btn-secondary"}>
                                            <span className={'d-block'}>ویرایش</span>
                                        </button>
                                        <button onClick={() => {
                                            const newStories = pageForm.stories.filter((s, i) => {
                                                if (index != i)
                                                    return s;
                                            });
                                            changeForm("stories", newStories);
                                        }} className={"btn btn-danger"}>
                                            <span className={'d-block'}>حذف</span>
                                        </button>
                                    </div>
                                )
                            })
                        }
                        {
                            storyModal.show &&
                            <StoryModal story={storyModal.index >= 0 ? pageForm.stories[storyModal.index] : {...story}}
                                        closeModal={() => {
                                            setStoryModal({...storyModal, show: false})
                                        }} onChange={(value) => {
                                if (storyModal.index < 0) {
                                    const newStories = [...pageForm.stories, {...value}];
                                    changeForm("stories", newStories);
                                    return;
                                }
                                const newStories = [...pageForm.stories];
                                newStories[storyModal.index] = value;
                                changeForm("stories", newStories);
                                return;
                            }}/>
                        }
                        <div className="col-md-4">
                            <div className="item">
                                <div className="item-body d-flex justify-content-center align-items-center">
                                    <button className={"btn btn-primary w-100 h-100"} onClick={() => {
                                        setStoryModal({...storyModal, index: -1, show: true})

                                    }}>
                                        ایجاد استوری
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <TextInput label={"عنوان صفحه"} value={pageForm.title} onChange={(value) => {
                            changeForm("title", value)
                        }}/>
                    </div>

                    <div className="col-12">
                        {
                            pageForm.rows.length == 0 && <div className="alert alert-warning">سطری تعریف نشده است!</div>
                        }
                        {
                            pageForm.rows.map((row, index) => {
                                return (
                                    <Fragment key={index}>
                                        <RenderRow row={row}
                                                   onChange={(value) => {
                                                       const newRows = [...pageForm.rows];
                                                       newRows[index] = value;
                                                       changeForm("rows", newRows);
                                                   }}
                                                   onEdit={() => {
                                                       const newRowModal = {...rowModal, show: true, index: index};
                                                       setRowModal(newRowModal);
                                                   }}
                                                   onDelete={() => {
                                                       const newRows = pageForm.rows.filter((row, i) => {
                                                           if (index != i) return row;
                                                       })
                                                       changeForm("rows", newRows);
                                                   }}/>
                                    </Fragment>
                                )
                            })
                        }
                        <button type={"button"} className={"btn btn-primary w-100"} onClick={() => {
                            const newRowModal = {...rowModal, show: true, index: -1};
                            setRowModal(newRowModal);
                        }}>افزودن سطر جدید
                        </button>

                        {rowModal.show &&
                            <RowModal row={rowModal.index >= 0 ? pageForm.rows[rowModal.index] : {...pageRow}}
                                      onChange={(value) => {
                                          if (rowModal.index >= 0) {
                                              const previousType = pageForm.rows[rowModal.index].type;
                                              const newRows = [...pageForm.rows];
                                              newRows[rowModal.index] = value;

                                              if (previousType != value.type) {
                                                  let items = [];
                                                  if (value.type == "SINGLE")
                                                      items = [{...rowItem}];
                                                  else if (value.type == "DOUBLE")
                                                      items = [{...rowItem}, {...rowItem}];
                                                  else if (value.type == "TRIPLE_RIGHT" || value.type == "TRIPLE_LEFT" || value.type == "TRIPLE_TOP" || value.type == "TRIPLE_BOTTOM")
                                                      items = [{...rowItem}, {...rowItem}, {...rowItem}];
                                                  else if (value.type == "QUADRUPLE")
                                                      items = [{...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}];
                                                  else if (value.type == "SEXTUPLE")
                                                      items = [{...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}];

                                                  newRows[rowModal.index].items = items;
                                              }

                                              changeForm("rows", newRows);
                                          } else {
                                              const newRows = [...pageForm.rows, {...value}];
                                              let items = [];
                                              if (value.type == "SINGLE")
                                                  items = [{...rowItem}];
                                              else if (value.type == "DOUBLE")
                                                  items = [{...rowItem}, {...rowItem}];
                                              else if (value.type == "TRIPLE_RIGHT" || value.type == "TRIPLE_LEFT" || value.type == "TRIPLE_TOP" || value.type == "TRIPLE_BOTTOM")
                                                  items = [{...rowItem}, {...rowItem}, {...rowItem}];
                                              else if (value.type == "QUADRUPLE")
                                                  items = [{...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}];
                                              else if (value.type == "SEXTUPLE")
                                                  items = [{...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}, {...rowItem}];

                                              newRows[newRows.length - 1].items = items;
                                              changeForm("rows", newRows);
                                          }
                                      }}
                                      closeModal={() => {
                                          const newRowModal = {...rowModal, show: false, index: ""}
                                          setRowModal(newRowModal);
                                      }}/>
                        }
                    </div>

                </div>
            </div>
        </div>
    );
}


const StoryModal = ({story, onChange, closeModal}) => {
    const [modalIsOpen, setIsOpen] = useState(true);
    const [storyForm, setStoryForm] = useState(story);

    function handleCloseModel() {
        closeModal();
    }

    const changeStory = (key, value) => {
        const newStory = {...storyForm, [key]: value};
        if (key == "picture") {
            newStory.video = "";
        } else if (key == "video") {
            newStory.picture = "";
        }
        setStoryForm(newStory);
    }

    return (
        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={handleCloseModel} contentLabel="Example Modal">
            <div className="row">
                <PickDateTime label={"تاریخ انقضای استوری"} timestamp={storyForm.expirationTimestamp}
                              onChange={(value) => {
                                  changeStory("expirationTimestamp", value)
                              }}/>
            </div>
            <div className="row">
                <label className="card-title text-center mb-4">تصویر</label>
                <div className="col-md-6">
                    <ImageInput aspect={3 / 5} onChange={(value) => {
                        changeStory("picture", value)
                    }}/>
                </div>
                <div className="col-md-6">
                    {storyForm.picture && <img className={"w-100"}
                                               src={storyForm.picture.includes("story") ? `${baseImagesUrl}story/${storyForm.picture}` : storyForm.picture}
                    />}
                </div>
            </div>
            <div className="row">
                <label className="card-title text-center mb-4">ویدئو</label>
                <div className="col-md-6">
                    <InputFileBase64 onChange={(value) => {
                        changeStory("video", value)
                    }}/>
                </div>
                <div className="col-md-6">
                    {storyForm.video && <video width="320" height="240" controls>
                        <source
                            src={storyForm.video.includes("story") ? `${baseImagesUrl}story/${storyForm.video}` : storyForm.video}
                            type="video/mp4"/>
                        <source
                            src={storyForm.video.includes("story") ? `${baseImagesUrl}story/${storyForm.video}` : storyForm.video}
                            type="video/ogg"/>
                        Your browser does not support the video tag.
                    </video>}
                </div>
            </div>

            <button className={"btn btn-primary float-left"} onClick={() => {
                onChange(storyForm);
                handleCloseModel();
            }}>ذخیره
            </button>

            <button className={"btn btn-danger float-left"} onClick={handleCloseModel}>بستن</button>
        </Modal>
    );

};
const RowModal = ({
                      row, onChange, closeModal
                  }) => {
    const rowTypeOptions = [
        {
            label: "خطی",
            value: "LINEAR",
        }, {
            label: "اسلایدر",
            value: "SLIDER",
        }, {
            label: "تک",
            value: "SINGLE",
        }, {
            label: "دابل",
            value: "DOUBLE",
        }, {
            label: "سه تایی (بالا کشیده)",
            value: "TRIPLE_TOP",
        }, {
            label: "سه تایی (پایین کشیده)",
            value: "TRIPLE_BOTTOM",
        }, {
            label: "سه تایی (راست کشیده)",
            value: "TRIPLE_RIGHT",
        }, {
            label: "سه تایی (چپ کشیده)",
            value: "TRIPLE_LEFT",
        }, {
            label: "چهار تایی",
            value: "QUADRUPLE",
        }, {
            label: "شش تایی",
            value: "SEXTUPLE",
        }
    ];
    const [rowForm, setRowForm] = useState(row);
    const [modalIsOpen, setIsOpen] = useState(true);

    const changeRow = (key, value) => {
        if (key == "toPageId" || key == "toProductCategoryId" || key == "toNewsCategoryId" || key == "toProductId" || key == "toNewsId" || key == "toBrandId") {
            const newRowForm = {
                ...rowForm,
                toPageId: "",
                toProductCategoryId: "",
                toNewsCategoryId: "",
                toProductId: "",
                toNewsId: "",
                toBrandId: "",
                [key]: value
            }
            setRowForm(newRowForm);
            return;
        }
        const newRowForm = {...rowForm, [key]: value}
        setRowForm(newRowForm);
    }

    function handleCloseModel() {
        closeModal();
    }

    return (
        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={handleCloseModel} contentLabel="Example Modal">
            <h2 className={"text-center my-2"}>افزودن سطر</h2>
            <div className="row">
                <div className="col-12">
                    <Select options={rowTypeOptions} label={"نوع سطر"} value={rowForm.type}
                            onChange={(value) => {
                                changeRow("type", value);
                            }}/>
                </div>
                <div className="col-md-6">
                    <TextInput label={"آیکون"} value={rowForm.icon} onChange={(value) => {
                        changeRow("icon", value)
                    }}/>
                </div>
                <div className="col-md-6">
                    <TextInput label={"عنوان سطر"} value={rowForm.title} onChange={(value) => {
                        changeRow("title", value)
                    }}/>
                </div>
                <div className="col-md-6">
                    <TextInput label={"عنوان دوم"} value={rowForm.subtitle} onChange={(value) => {
                        changeRow("subtitle", value)
                    }}/>
                </div>
                <div className="col-12">
                    <h2 className={'text-center mb-4'}>ارجاع شود به</h2>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی دسته بندی محصول"} value={rowForm.toProductCategoryId}
                               onChange={(value) => {
                                   changeRow("toProductCategoryId", value)
                               }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی محصول"} value={rowForm.toProductId} onChange={(value) => {
                        changeRow("toProductId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی پیج"} value={rowForm.toPageId} onChange={(value) => {
                        changeRow("toPageId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی برند"} value={rowForm.toBrandId} onChange={(value) => {
                        changeRow("toBrandId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی دسته بندی خبر"} value={rowForm.toNewsCategoryId}
                               onChange={(value) => {
                                   changeRow("toNewsCategoryId", value)
                               }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی خبر"} value={rowForm.toNewsId} onChange={(value) => {
                        changeRow("toNewsId", value)
                    }}/>
                </div>

            </div>

            <button className={"btn btn-primary float-left"} onClick={() => {
                onChange(rowForm);
                handleCloseModel();
            }}>ذخیره
            </button>

            <button className={"btn btn-danger float-left"} onClick={handleCloseModel}>بستن</button>
        </Modal>);

};
const RenderRow = ({row, onChange, onEdit, onDelete}) => {

    return (
        <div className={"card"}>
            <div className="card-body">
                <div className="d-flex justify-content-between mb-2">
                    <h5>{row.title}</h5>
                    <h6>{row.subtitle}</h6>
                </div>
                {row.type == "LINEAR" && <Linear items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "SLIDER" && <Slider items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "SINGLE" && <Single items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "DOUBLE" && <Double items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "TRIPLE_RIGHT" && <TripleRight items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "TRIPLE_LEFT" && <TripleLeft items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "TRIPLE_TOP" && <TripleTop items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "TRIPLE_BOTTOM" && <TripleBottom items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "QUADRUPLE" && <Quadruple items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                {row.type == "SEXTUPLE" && <Sextuple items={row.items} onChange={(value) => {
                    const newRow = {...row};
                    newRow.items = [...value];
                    onChange(newRow);
                }}/>}
                <div className="d-flex justify-content-between mt-4">
                    <button className="btn btn-sm btn-secondary" type={"button"} onClick={onEdit}>
                        ویرایش سطر
                    </button>
                    <button className="btn btn-sm btn-danger" type={"button"} onClick={onDelete}>
                        حذف سطر
                    </button>
                </div>
            </div>
        </div>
    );

};
const Slider = ({items, onChange}) => {
    const rowItem = {
        productId: "",
        banner: "",
        toPageId: "",
        toProductCategoryId: "",
        toNewsCategoryId: "",
        toProductId: "",
        toNewsId: "",
        toBrandId: "",
        parameters: "",
    };
    return (<div className={"row"}>

        {
            items.map((item, index) => {
                return (
                    <div key={index} className="col-md-4">
                        <Item item={item} onChange={(value) => {
                            const newItems = [...items];
                            newItems[index] = {...value};
                            onChange(newItems);
                        }}/>
                        <button onClick={() => {
                            const newItems = items.filter((item, i) => {
                                if (index != i)
                                    return item;
                            });
                            onChange(newItems);
                        }} className={"btn btn-danger"}>
                            <span className={'d-block'}>حذف کردن آیتم</span>
                        </button>
                    </div>
                )
            })
        }
        <div className="col-md-4">
            <div className="item">
                <div className="item-body d-flex justify-content-center align-items-center">
                    <button onClick={() => {
                        const newItems = [...items, {...rowItem}];
                        onChange(newItems);
                    }} className={"btn btn-secondary"}>
                        <FontAwesomeIcon icon={faPlus}/>
                        <span className={'d-block'}>اضافه کردن آیتم</span>
                    </button>
                </div>
            </div>
        </div>
    </div>);
}
const Linear = ({items, onChange}) => {
    const rowItem = {
        productId: "",
        banner: "",
        toPageId: "",
        toProductCategoryId: "",
        toNewsCategoryId: "",
        toProductId: "",
        toNewsId: "",
        toBrandId: "",
        parameters: "",
    };
    return (<div className={"row"}>

        {
            items.map((item, index) => {
                return (
                    <div key={index} className="col-md-4">
                        <Item item={item} onChange={(value) => {
                            const newItems = [...items];
                            newItems[index] = {...value};
                            onChange(newItems);
                        }}/>
                        <button onClick={() => {
                            const newItems = items.filter((item, i) => {
                                if (index != i)
                                    return item;
                            });
                            onChange(newItems);
                        }} className={"btn btn-danger"}>
                            <span className={'d-block'}>حذف کردن آیتم</span>
                        </button>
                    </div>
                )
            })
        }
        <div className="col-md-4">
            <div className="item">
                <div className="item-body d-flex justify-content-center align-items-center">
                    <button onClick={() => {
                        const newItems = [...items, {...rowItem}];
                        onChange(newItems);
                    }} className={"btn btn-secondary"}>
                        <FontAwesomeIcon icon={faPlus}/>
                        <span className={'d-block'}>اضافه کردن آیتم</span>
                    </button>
                </div>
            </div>
        </div>
    </div>);
}
const Single = ({items, onChange}) => {

    return (
        <div className="row">
            <div className="col-12">
                <Item item={items[0]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[0] = {...value};
                    onChange(newItems);
                }}/>
            </div>
        </div>
    );
}
const Double = ({items, onChange}) => {
    return (
        <div className="row">
            <div className="col-md-6">
                <Item item={items[0]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[0] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-6">
                <Item item={items[1]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[1] = {...value};
                    onChange(newItems);
                }}/>
            </div>
        </div>
    );
}
const TripleTop = ({items, onChange}) => {
    return (
        <div className="row">
            <div className="col-12">
                <Item item={items[0]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[0] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-6">
                <Item item={items[1]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[1] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-6">
                <Item item={items[2]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[2] = {...value};
                    onChange(newItems);
                }}/>
            </div>
        </div>
    );
}
const TripleBottom = ({items, onChange}) => {
    return (<div className="row">
        <div className="col-md-6">
            <Item item={items[0]} onChange={(value) => {
                const newItems = [...items];
                newItems[0] = {...value};
                onChange(newItems);
            }}/>
        </div>
        <div className="col-md-6">
            <Item item={items[1]} onChange={(value) => {
                const newItems = [...items];
                newItems[1] = {...value};
                onChange(newItems);
            }}/>
        </div>
        <div className="col-12">
            <Item item={items[2]} onChange={(value) => {
                const newItems = [...items];
                newItems[2] = {...value};
                onChange(newItems);
            }}/>
        </div>
    </div>);
}
const TripleRight = ({items, onChange}) => {
    return (
        <div className="row">
            <div className="col-md-6">
                <Item item={items[0]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[0] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-6">
                <div className="row">
                    <div className="col-12">
                        <Item item={items[1]} onChange={(value) => {
                            const newItems = [...items];
                            newItems[1] = {...value};
                            onChange(newItems);
                        }}/>
                    </div>
                    <div className="col-12">
                        <Item item={items[2]} onChange={(value) => {
                            const newItems = [...items];
                            newItems[2] = {...value};
                            onChange(newItems);
                        }}/>
                    </div>
                </div>
            </div>

        </div>);
}
const TripleLeft = ({items, onChange}) => {
    return (<div className="row">
        <div className="col-md-6">
            <div className="row">
                <div className="col-12">
                    <Item item={items[0]} onChange={(value) => {
                        const newItems = [...items];
                        newItems[0] = {...value};
                        onChange(newItems);
                    }}/>
                </div>
                <div className="col-12">
                    <Item item={items[1]} onChange={(value) => {
                        const newItems = [...items];
                        newItems[1] = {...value};
                        onChange(newItems);
                    }}/>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <Item item={items[2]} onChange={(value) => {
                const newItems = [...items];
                newItems[2] = {...value};
                onChange(newItems);
            }}/>
        </div>
    </div>);
}
const Quadruple = ({items, onChange}) => {
    return (<div className="row">
        <div className="col-md-6">
            <Item item={items[0]} onChange={(value) => {
                const newItems = [...items];
                newItems[0] = {...value};
                onChange(newItems);
            }}/>
        </div>
        <div className="col-md-6">
            <Item item={items[1]} onChange={(value) => {
                const newItems = [...items];
                newItems[1] = {...value};
                onChange(newItems);
            }}/>
        </div>
        <div className="col-md-6">
            <Item item={items[2]} onChange={(value) => {
                const newItems = [...items];
                newItems[2] = {...value};
                onChange(newItems);
            }}/>
        </div>
        <div className="col-md-6">
            <Item item={items[3]} onChange={(value) => {
                const newItems = [...items];
                newItems[3] = {...value};
                onChange(newItems);
            }}/>
        </div>
    </div>);
}
const Sextuple = ({items, onChange}) => {
    return (
        <div className={"row"}>
            <div className="col-md-4">
                <Item item={items[0]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[0] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-4">
                <Item item={items[1]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[1] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-4">
                <Item item={items[2]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[2] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-4">
                <Item item={items[3]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[3] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-4">
                <Item item={items[4]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[4] = {...value};
                    onChange(newItems);
                }}/>
            </div>
            <div className="col-md-4">
                <Item item={items[5]} onChange={(value) => {
                    const newItems = [...items];
                    newItems[5] = {...value};
                    onChange(newItems);
                }}/>
            </div>
        </div>
    );
}

const Item = ({item, onChange}) => {
    const [itemModal, setItemModal] = useState(false);

    return (
        <div className={"item mt-2"}>
            <div className="item-body">
                {item.banner && <img className={"w-100"}
                                     src={item.banner.includes("banner") ? `${baseImagesUrl}page/${item.banner}` : item.banner}
                />}

                {item.productId && <h1>Product Id #{item.productId}</h1>}

                {itemModal && <ItemModal item={item}
                                         onChange={(value) => {
                                             onChange(value)
                                         }}
                                         closeModal={() => {
                                             setItemModal(false)
                                         }}/>}
            </div>


            <div className="item-footer text-center">
                <button className={"btn btn-sm btn-secondary w-100"} onClick={() => {
                    setItemModal(true)
                }}
                >ویرایش آیتم
                </button>
            </div>

        </div>
    );


};

const ItemModal = ({item, onChange, closeModal}) => {

    const rowTypeOptions = [
        {
            label: "محصول",
            value: "PRODUCT",
        }, {
            label: "بنر",
            value: "BANNER",
        },
    ];

    const [itemType, setItemType] = useState((!item.banner && !item.productId) || item.banner ? "BANNER" : "");
    const [itemForm, setItemForm] = useState(item);
    const [modalIsOpen, setIsOpen] = useState(true);

    const changeItem = (key, value) => {
        if (key == "toPageId" || key == "toProductCategoryId" || key == "toNewsCategoryId" || key == "toProductId" || key == "toNewsId" || key == "toBrandId") {
            const newItemForm = {
                ...itemForm,
                toPageId: "",
                toProductCategoryId: "",
                toNewsCategoryId: "",
                toProductId: "",
                toNewsId: "",
                toBrandId: "",
                [key]: value
            }
            setItemForm(newItemForm);
            return;
        } else if (key == "productId" || key == "banner") {
            const newItemForm = {
                ...itemForm,
                productId: "",
                banner: "",
                [key]: value
            }
            setItemForm(newItemForm);
            return;
        }
        const newItemForm = {...itemForm, [key]: value}
        setItemForm(newItemForm);
    }

    function handleCloseModel() {
        closeModal();
    }

    return (
        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={handleCloseModel} contentLabel="Example Modal">
            <h2 className={"text-center my-2"}>ویرایش آیتم</h2>
            <div className="row">
                <div className="col-12">
                    <Select options={rowTypeOptions} label={"نوع آیتم"} value={itemType || "PRODUCT"}
                            onChange={(value) => {
                                changeItem("banner", "");
                                setItemType(value);
                            }}/>
                </div>

                {
                    (itemForm.banner || itemType == "BANNER") && <div>
                        <InputFileBase64 label={"انتخاب بنر"} onChange={(value) => {
                            changeItem("banner", value)
                        }}/>
                        <div className="col-md-6">
                            <img className={"w-100"}
                                 src={item.banner ? (item.banner.includes("banner") ? `${baseImagesUrl}page/${item.banner}` : item.banner) : ""}
                            />
                        </div>

                    </div>
                }
                {
                    (itemForm.productId || itemType == "PRODUCT") &&
                    <TextInput label={"آیدی محصول"} value={itemForm.productId} onChange={(value) => {
                        changeItem("productId", value)
                    }}/>
                }

                <div className="col-12">
                    <h2 className={'text-center mb-4'}>ارجاع شود به</h2>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی دسته بندی محصول"} value={itemForm.toProductCategoryId}
                               onChange={(value) => {
                                   changeItem("toProductCategoryId", value)
                               }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی محصول"} value={itemForm.toProductId} onChange={(value) => {
                        changeItem("toProductId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی پیج"} value={itemForm.toPageId} onChange={(value) => {
                        changeItem("toPageId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی برند"} value={itemForm.toBrandId} onChange={(value) => {
                        changeItem("toBrandId", value)
                    }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی دسته بندی خبر"} value={itemForm.toNewsCategoryId}
                               onChange={(value) => {
                                   changeItem("toNewsCategoryId", value)
                               }}/>
                </div>
                <div className="col-12">
                    <TextInput type={'number'} label={"آیدی خبر"} value={itemForm.toNewsId} onChange={(value) => {
                        changeItem("toNewsId", value)
                    }}/>
                </div>

            </div>

            <button className={"btn btn-primary float-left"} onClick={() => {
                onChange(itemForm);
                handleCloseModel();
            }}>ذخیره
            </button>

            <button className={"btn btn-danger float-left"} onClick={handleCloseModel}>بستن</button>
        </Modal>);

};


export default PageForm;